import {
  type ScratchcardDetail,
  ScratchcardState,
} from '#api/shared/@types/generated/backend/graphql-schema-types'

export const byNotCancelled = (scratchcard: ScratchcardDetail) =>
  scratchcard.status !== ScratchcardState.Cancelled

export const byWin = (
  { winningsPayload: winningsA }: ScratchcardDetail,
  { winningsPayload: winningsB }: ScratchcardDetail,
) => (winningsB?.amount?.value ?? 0) - (winningsA?.amount?.value ?? 0)

export const isCancelled = (state: ScratchcardState) => state === ScratchcardState.Cancelled

export const isInProgress = (state: ScratchcardState) =>
  [ScratchcardState.InProgress, ScratchcardState.Purchased].includes(state)

export const isRevealed = (state: ScratchcardState) => state === ScratchcardState.Revealed

export const isRevealing = (state: ScratchcardState) => state === ScratchcardState.Scratched

export const isScratchcardRevealed = (scratchcard: ScratchcardDetail) =>
  isRevealed(scratchcard.status)

export const isScanPresent = (state: ScratchcardState) =>
  [ScratchcardState.Revealed, ScratchcardState.Scratched].includes(state)

export const toSerialNumber = ({ serialNumber }: ScratchcardDetail) => serialNumber
